export default {"src":"/_next/static/media/Booking.com_logo.cbc0e808.svg","height":20,"width":119,"blurWidth":0,"blurHeight":0};